import { IMenuItemEntry } from '@move-frontend/contentful';
import { useEffect, useState } from 'react';
import { IOtherWebsitesEntry } from '../../../../contentful/types/IMenuItem';
import {
	StyledSubmenuItemWrap,
	StyledSubmenuItem,
	SubMenuHeader,
	Container,
	ListContainer,
} from './SubMenu.styles';
import { Responsive } from '../../../../ui';
import {
	adaptSiteSectionsToSubMenuItem,
	adaptSubMenuItems,
} from '../../../../utils/getMenuItemMapping';
import { useCommonData } from '../../../../common-data/useCommonData';
import { ISiteSectionEntry } from '../../../../contentful/types/ISiteSection';
import { IMenuItemNavBar } from '../../../../contentful/types/IMenuItemNavBar';
import { OTHER_WEBSITES_SITE_SECTION_ID } from '../../../../contentful';

interface ISubNavigationProps {
	open: boolean;
	parentItem?: IMenuItemEntry | IOtherWebsitesEntry;
	onClick?: (id: string) => void;
}
export const SubMenu = ({ parentItem, open, onClick }: ISubNavigationProps) => {
	const { pathToPageIdMap } = useCommonData();
	const isSmallDesktop = Responsive.useMatchesBreakpoint('desktop');
	const [subMenuItems, setSubmenuItems] = useState<IMenuItemNavBar[]>([]);

	useEffect(() => {
		if (parentItem) setSubmenuItems(getSubMenuItems(parentItem));
	}, [parentItem]);

	const getSubMenuItems = (item: IOtherWebsitesEntry | IMenuItemEntry) =>
		item?.id === OTHER_WEBSITES_SITE_SECTION_ID
			? adaptSiteSectionsToSubMenuItem(
					item.fields.subMenuItems as ISiteSectionEntry[],
					pathToPageIdMap,
			  )
			: adaptSubMenuItems(
					pathToPageIdMap,
					item.fields.subMenuItems as IMenuItemEntry[],
			  );
	return (
		<Container open={open}>
			<>
				{!isSmallDesktop && (
					<SubMenuHeader>{parentItem?.fields.title}</SubMenuHeader>
				)}
				<ListContainer>
					{subMenuItems.map((item, index) => (
						<StyledSubmenuItemWrap
							// eslint-disable-next-line react/no-array-index-key
							key={`${item.id}-${index}`}
							onClick={() => onClick && onClick(item.id)}
						>
							{item.url && (
								<StyledSubmenuItem href={item.url}>
									{item.title}
								</StyledSubmenuItem>
							)}
						</StyledSubmenuItemWrap>
					))}
				</ListContainer>
			</>
		</Container>
	);
};
